export interface IFetching {
  loading?: boolean;
  error?: any;
}

export enum AREA {
  SOUTHERN = 'HCM',
  NORTHERN = 'HN',
}
